module.exports = __webpack_public_path__ + "img/galeria-plantas-vasculares2.a1232d2f.jpg";